module.exports = __webpack_public_path__ + "static/img/cybercrime_2.2d9459ff.png";